var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16.082,
    viewBox: "0 0 16.082 16.082",
    width: 16.082,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.291 2.25a8.041 8.041 0 1 0 8.041 8.041 7.992 7.992 0 0 0 -8.041-8.041zm3.1 12.062-3.1-3.1-3.1 3.1-.919-.919 3.1-3.1-3.1-3.1.919-.919 3.1 3.1 3.1-3.1.919.919-3.1 3.1 3.1 3.1z",
    fill: "#8e2627",
    transform: "translate(-2.25 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFilled);
export default __webpack_public_path__ + "static/media/error-filled.eaa0e78fcb58300ec4c13d9ec2aa617d.svg";
export { ForwardRef as ReactComponent };